const key = (appId: string | number, stepKey: string) =>
  `cbc-quarantine:${appId}:${stepKey}`;
const memoryFallback = new Map<string, unknown>();

/**
 * Session-scoped cache for replacement attribution. This survives reloads and
 * remounts without becoming a durable database or a source of applicant data.
 */
export const cbcQuarantineSession = {
  async load<T>(
    appId: string | number,
    stepKey: string,
  ): Promise<T | undefined> {
    const cacheKey = key(appId, stepKey);
    if (memoryFallback.has(cacheKey)) {
      return memoryFallback.get(cacheKey) as T;
    }
    const raw = sessionStorage.getItem(cacheKey);
    if (!raw) return undefined;
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed as T
      : undefined;
  },

  async save(
    appId: string | number,
    stepKey: string,
    entries: unknown,
  ): Promise<void> {
    const cacheKey = key(appId, stepKey);
    memoryFallback.set(cacheKey, entries);
    sessionStorage.setItem(cacheKey, JSON.stringify(entries));
  },

  async clear(appId: string | number, stepKey: string): Promise<void> {
    const cacheKey = key(appId, stepKey);
    memoryFallback.delete(cacheKey);
    sessionStorage.removeItem(cacheKey);
  },
};
